import { useCallback, useMemo, useState } from 'react';
import { listOrgQuotes } from '../infra/quotesRepo';
import type { QuoteListFilter, ServiceQuoteRequest } from '../domain/types';

export function useQuotesList(
  branchId: string | null | undefined,
  filter: QuoteListFilter = 'all',
) {
  const [items, setItems] = useState<ServiceQuoteRequest[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const query = useMemo(
    () => ({ branchId: branchId ?? null, filter }),
    [branchId, filter],
  );

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listOrgQuotes(query.branchId, query.filter);
      setItems(data);
    } catch (e) {
      const message = e instanceof Error ? e.message : 'No se pudieron cargar las cotizaciones.';
      console.error('useQuotesList', e);
      setError(message);
    } finally {
      setLoading(false);
    }
  }, [query]);

  return { quotes: items, loading, error, reload };
}
